import { type IntentT } from '../intent-list/intent-list';
import type { GetIntentInfoT, LabelledIntentT, TextIntentT, TextMap } from '../text-panel/text-panel';
const getIntentIndex = (intentArr: Array<LabelledIntentT | undefined | null>, intent: LabelledIntentT) => {
  return intentArr.findIndex(textIntent => textIntent?.value === intent.value && textIntent?.startIndex === intent.startIndex && textIntent?.endIndex === intent.endIndex);
};
const getIntentDepth = (textMap: TextMap[], startIndex: number, endIndex: number) => {
  let depthFound = false;
  let currentDepth = -1;
  while (!depthFound) {
    currentDepth++;
    // Check if current range is empty for the currentDepth
    depthFound = textMap.slice(startIndex, endIndex + 1).every(word => typeof word.intents[currentDepth] !== 'object' || word.intents[currentDepth] === null);
  }
  return currentDepth;
};
const labelText = ({
  textMap,
  startIndex,
  endIndex,
  currentIntent,
  selectionCounter
}: {
  textMap: TextMap[];
  startIndex: number;
  endIndex: number;
  currentIntent: IntentT;
  selectionCounter: number;
}) => {
  const _updatedTextMap = [...textMap];

  // Check if same range for same intent already exists
  if (
  // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
  getIntentIndex(_updatedTextMap[startIndex].intents, {
    value: currentIntent.value,
    startIndex,
    endIndex,
    depth: -1,
    // Random value we don't care abt depth while matching
    color: currentIntent.color,
    selectionCounter: -1 // Random value
  }) !== -1) {
    return null;
  }
  const depth = getIntentDepth(_updatedTextMap, startIndex, endIndex);

  // Push intent in each word
  for (let i = startIndex; i <= endIndex; i++) {
    const word = _updatedTextMap[i];
    // @ts-expect-error todo(ts-migration) TS18048 'word' is possibly 'undefined'.
    word.intents[depth] = {
      value: currentIntent.value,
      color: currentIntent.color,
      startIndex,
      endIndex,
      depth,
      selectionCounter
    };
  }
  return _updatedTextMap;
};
const recalculateDepths = (textMap: TextMap[], startIndex: number, endIndex: number) => {
  const _textMap = [...textMap];
  for (let wordIdx = startIndex; wordIdx <= endIndex; wordIdx++) {
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    for (let intentIdx = 0; intentIdx < _textMap[wordIdx].intents.length; intentIdx++) {
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      const intent = _textMap[wordIdx].intents[intentIdx];
      if (intent) {
        // Find out if any empty depth exists for this range
        const depth = getIntentDepth(_textMap, intent.startIndex, intent.endIndex);
        if (depth < intent.depth) {
          const oldDepth = intent.depth;
          // Shift intent to the new found depth index and delete at existing location
          for (let i = intent.startIndex; i <= intent.endIndex; i++) {
            // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
            _textMap[i].intents[depth] = _textMap[i].intents[oldDepth];
            // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
            if (_textMap[i].intents[depth]) {
              // @ts-expect-error missing null check
              _textMap[i].intents[depth].depth = depth;
            }
            // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
            _textMap[i].intents[oldDepth] = null;
          }
        }
      }
    }

    // reduce length of array if ends contain null values
    let firstNonNullIdx = -1;
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    const reversedIntentArr = _textMap[wordIdx].intents.slice().reverse();
    for (let intentIdx = 0; intentIdx < reversedIntentArr.length; intentIdx++) {
      if (reversedIntentArr[intentIdx]) {
        firstNonNullIdx = intentIdx;
        break;
      }
    }
    if (firstNonNullIdx !== 0) {
      // If idx is 0 no need to trim array
      if (firstNonNullIdx === -1) {
        // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
        _textMap[wordIdx].intents = [];
      } else {
        // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
        _textMap[wordIdx].intents.splice(-firstNonNullIdx);
      }
    }
  }
  return _textMap;
};
const removeIntentAndRecalculate = (textMap: TextMap[], intent: LabelledIntentT) => {
  let minStartIndex = intent.startIndex,
    maxEndIndex = intent.endIndex;

  // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
  const removedIntentIdx = getIntentIndex(textMap[intent.startIndex].intents, intent);
  if (removedIntentIdx === -1) return null;
  for (let i = intent.startIndex; i <= intent.endIndex; i++) {
    // Get start & end index for the intents affected by this deletion
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    for (let intentIdx = removedIntentIdx + 1; intentIdx < textMap[i].intents.length; intentIdx++) {
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      const selectedIntent = textMap[i].intents[intentIdx];
      if (selectedIntent) {
        minStartIndex = Math.min(selectedIntent.startIndex, minStartIndex);
        maxEndIndex = Math.max(selectedIntent.endIndex, maxEndIndex);
      }
    }

    // Remove the intent from the word
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    textMap[i].intents[removedIntentIdx] = null;
  }
  return recalculateDepths(textMap, minStartIndex, maxEndIndex);
};
const textMapToIntentArr = (textMap: TextMap[]): TextIntentT[] => {
  const intentArr = textMap.reduce((intentArr, word, wordIndex) => {
    if (word.intents.length === 0) {
      return intentArr;
    }
    word.intents.filter(intent => intent).map(intent => {
      if (!intent) return;
      // Annotation starts at this word
      if (intent.startIndex === wordIndex) {
        const text = textMap.slice(intent.startIndex, intent.endIndex + 1).map(text => text.word).join(' ');
        const startIndex = word.startCharIndex;
        const endIndex = startIndex + text.length - 1;
        // @ts-expect-error missing null check
        intentArr.push({
          text,
          startIndex,
          endIndex,
          intent: intent.value,
          selectionCounter: intent.selectionCounter
        });
      }
    });
    return intentArr;
  }, []);
  return intentArr
  // @ts-expect-error missing null check
  .sort((intentA, intentB) => intentA.selectionCounter - intentB.selectionCounter)
  // @ts-expect-error missing null check
  .map(({
    selectionCounter,
    ...intentProps
  }) => intentProps);
};
const getInitialTextMap = (text: string, intentArr: TextIntentT[], getIntentInfo: GetIntentInfoT) => {
  let startCharIndex = 0;
  const depthMap = {};
  const textMap = text.split(' ').map((word, wordIndex) => {
    const textObj = {
      word,
      intents: [],
      startCharIndex
    };
    const matchedIntents = intentArr.filter(label => startCharIndex >= label.startIndex && startCharIndex + word.length - 1 <= label.endIndex);
    matchedIntents.forEach(textIntent => {
      const textArr = textIntent.text.split(' ');
      const startIndex = wordIndex - textArr.findIndex(text => text === word);
      const endIndex = startIndex + textArr.length - 1;

      // Get max depth at which this intent will be stored...will be recalculated later
      // Cache the depth to assign this intent the same depth in each word
      const intentDepth = depthMap[`${textIntent.intent}:${startIndex}:${endIndex}`] || (textObj.intents[intentArr.length] ? intentArr.length + 1 : intentArr.length);
      depthMap[`${textIntent.intent}:${startIndex}:${endIndex}`] = intentDepth;

      // @ts-expect-error missing null check
      textObj.intents[intentDepth] = {
        //Assign to a max value
        value: textIntent.intent,
        color: getIntentInfo(textIntent.intent).color,
        startIndex,
        endIndex,
        depth: intentDepth,
        selectionCounter: intentArr.findIndex(intent => intent.text === textIntent.text && intent.intent === textIntent.intent && intent.startIndex === textIntent.startIndex && intent.endIndex === textIntent.endIndex)
      };
    });
    startCharIndex += word.length + 1;
    return textObj;
  });
  return recalculateDepths(textMap, 0, textMap.length - 1);
};
export { getIntentIndex, labelText, getIntentDepth, recalculateDepths, removeIntentAndRecalculate, textMapToIntentArr, getInitialTextMap };